import { css } from '@compiled/react';
// @ts-ignore
import { useInView } from 'react-intersection-observer';
import { useIntl } from 'react-intl';

import {
	JiraOverlayTemplate,
	JPDOverlayTemplate,
} from '@/components/signup/layouts/product-overlay-template';
import { UpgradeEligibleUser } from '@/components/signup/site-activation/components/upgrade-eligible-user/upgrade-eligible-user';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';
import { useCohort, useLoggedInHasJira } from '@/components/user-context/helpers/cohorts';
import type { ExistingSite } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

import { Headings } from '../../../components/headings';
import { SitesAreSharedSpacesText } from '../../../components/sub-heading';
import { SubmitButtonMessageNext } from '../../../components/submit-button-message-next';
import { WelcomeBackText } from '../../../components/welcome-back-heading';
import { useGetExistingSites } from '../../../utils/get-existing-sites/use-get-existing-sites';
import { LoggedInJpdNewUser } from '../free/new-user';

export const LoggedInJpdPremium = () => {
	const { ref } = useInView();
	const cohort = useCohort();
	const isLoggedInHasJira = useLoggedInHasJira();

	// Upgradeable Standard Sites Experiment
	const existingSites = useGetExistingSites();

	if (cohort === 'new-user') {
		return <LoggedInJpdNewUser />;
	}

	if (isLoggedInHasJira) {
		return (
			<div ref={ref}>
				<JiraOverlayTemplate size="sm">
					<Content existingSites={existingSites} />
				</JiraOverlayTemplate>
			</div>
		);
	}

	return (
		<div ref={ref}>
			<JPDOverlayTemplate size="sm">
				<Content existingSites={existingSites} />
			</JPDOverlayTemplate>
		</div>
	);
};

const Content = ({ existingSites }: { existingSites?: ExistingSite[] }) => {
	const { formatMessage } = useIntl();

	const siteActivationContent = existingSites ? (
		<UpgradeEligibleUser SubmitButton={<SubmitButtonMessageNext />} />
	) : undefined;

	return (
		<>
			<Headings main={<WelcomeBackText />} sub={<SitesAreSharedSpacesText />} />
			<SiteActivation
				existingSites={existingSites}
				UpgradeEligibleUser={siteActivationContent}
				CurrentProductUser={siteActivationContent}
				WeekOneUser={siteActivationContent ?? null}
			/>
			<footer css={footerCss}>
				{formatMessage({
					id: 'JiraSoftwarePageTemplate.loggedInHero.recatcha',
					defaultMessage:
						'This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.',
				})}
			</footer>
		</>
	);
};

const footerCss = css({
	fontSize: 12,
	fontWeight: 400,
	margin: 0,
	fontFamily: 'Charlie Text',
});
